import { render, staticRenderFns } from "./CACA-Junior.vue?vue&type=template&id=ff8f81ee&scoped=true"
import script from "./CACA-Junior.vue?vue&type=script&lang=js"
export * from "./CACA-Junior.vue?vue&type=script&lang=js"
import style0 from "./CACA-Junior.vue?vue&type=style&index=0&id=ff8f81ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8f81ee",
  null
  
)

export default component.exports